import React from "react";
import styles from "../_css/leadPage.module.css";

type Props = {
    label: string;
    text: string;
    icon?: React.ReactNode;
};

export function LeadGroupText({ label, text, icon }: Props) {
    return (
        <div className={styles.group}>
            <div className={styles.labelRow}>
                {icon && <span className={styles.icon}>{icon}</span>}
                <label className={styles.label}>{label}</label>
            </div>
            <div className={styles.readonlyText}>{text !== "" ? text : "/"}</div>
        </div>
    );
}
